import OpenBannerSetFromNuxeo from './components/OpenBannerSetFromNuxeo';

export { OpenBannerSetFromNuxeo };
